import { render, staticRenderFns } from "./officeSuppliesCollectionHis.vue?vue&type=template&id=79adb402&scoped=true"
import script from "./officeSuppliesCollectionHis.vue?vue&type=script&lang=js"
export * from "./officeSuppliesCollectionHis.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesCollectionHis.vue?vue&type=style&index=0&id=79adb402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79adb402",
  null
  
)

export default component.exports